module.exports = __webpack_public_path__ + "static/media/ghd_banner.4afc0377.png";